import palette from "../../styles/brandPalette.json";
import logoSpec from "../../styles/logoTokens.json";

export const logoTokens = Object.freeze({
  brandName: logoSpec.brandName,
  monogram: logoSpec.monogram,
  mark: {
    viewBox: logoSpec.mark.viewBox,
    strokeWidth: logoSpec.mark.strokeWidth,
    vStrokeWidth: logoSpec.mark.vStrokeWidth,
    leftBracket: logoSpec.mark.leftBracket,
    rightBracket: logoSpec.mark.rightBracket,
    vPoints: logoSpec.mark.vPoints,
    bracket: logoSpec.mark.bracket,
    vColor: logoSpec.mark.vColor,
  },
  wordmark: {
    fontWeight: logoSpec.wordmark.fontWeight,
    letterSpacing: `${(logoSpec.wordmark.letterSpacing / logoSpec.wordmark.fontSize).toFixed(4)}em`,
    color: {
      light: palette.logo.wordmark,
      dark: "#FFFFFF",
    },
    accent: {
      light: palette.logo.accent,
      dark: palette.logo.accentDark,
    },
  },
  tagline: {
    fontWeight: logoSpec.tagline.fontWeight,
    letterSpacing: `${(logoSpec.tagline.letterSpacing / logoSpec.tagline.fontSize).toFixed(4)}em`,
    color: {
      light: logoSpec.tagline.color,
      dark: "#D8E0EA",
    },
  },
  // Render sizes are tuned so mark height closely matches wordmark cap-height
  // for an optically balanced lockup at every size.
  sizes: Object.freeze({
    sm: { mark: 28, wordmark: "1rem", tagline: "0.7rem", gap: 10 },
    md: { mark: 36, wordmark: "1.25rem", tagline: "0.78rem", gap: 12 },
    lg: { mark: 48, wordmark: "1.625rem", tagline: "0.9rem", gap: 14 },
    xl: { mark: 64, wordmark: "2.125rem", tagline: "1rem", gap: 18 },
  }),
  fontStack: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
});

export const resolveSize = (size) => {
  if (typeof size === "number") {
    return { mark: size, wordmark: `${size * 0.5}px`, tagline: `${size * 0.28}px`, gap: Math.round(size * 0.3) };
  }
  return logoTokens.sizes[size] ?? logoTokens.sizes.md;
};

export const resolveTone = (tone) => (tone === "dark" ? "dark" : "light");
